import { render, staticRenderFns } from "./documentationDataForm.vue?vue&type=template&id=393e6b9c&"
import script from "./documentationDataForm.vue?vue&type=script&lang=js&"
export * from "./documentationDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports